import { makeStyles, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

interface Props {
  label: string;
  value: string;
  big?: boolean;
  bordered?: boolean;
}
const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    flexDirection: "column",
    margin: "2.5mm 0mm",
  },
  textWrapper: {
    borderRadius: "0px",
    width: "100%",
    height: "10mm",
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  border: {
    borderTop: "0.01em solid lightgray",
  },
}));
const TextBox: React.FC<Props> = ({ label, value, big, bordered = true }) => {
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <Typography variant="subtitle1">{label}</Typography>
      <div
        style={{ ...(big && { height: "80px" }) }}
        className={clsx(classes.textWrapper, {
          [classes.border]: bordered,
        })}
      >
        <Typography style={{ padding: "0mm 10px" }} variant="button">
          {value}
        </Typography>
      </div>
    </div>
  );
};

export default TextBox;
